// Enum for business regions
export enum BusinessRegion {
  ChineseMainland = '_SYS_BR_1',
  HongKong = '_SYS_BR_2',
  Taiwan = '_SYS_BR_3',
  Vietnam = '_SYS_BR_4',
  Cambodia = '_SYS_BR_5',
  UnitedStates = '_SYS_BR_6',
  Thailand = '_SYS_BR_7',
  Laos = '_SYS_BR_8'
}
